module.exports = __webpack_public_path__ + "static/media/widget3-img2.9df0a6da.jfif";